<script>
export default {
  name: 'UlRow',
  props: {
    card: {
      type: Boolean,
      default: false,
    },
    flex: {
      type: Boolean,
      default: false,
    },
    bottom: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classes() {
      return {
        'ul-row--flex': this.flex,
        'ul-row--card': this.card,
        'ul-row--bottom': this.bottom,
      };
    },
  },
};
</script>
<template>
  <div class="ul-row" :class="classes">
    <slot></slot>
  </div>
</template>
<style lang="scss">
  .ul-row {
    margin: 0 -12px;

    &--flex {
      display: flex;

      & > .ul-col {
        flex-shrink: 1;
      }
    }

    &--bottom {
      margin-bottom: 24px;
    }

    &--card {
      display: flex;
      margin-bottom: 24px;

      & > .ul-col {

        & > .ul-card {
          height: 100%;
          margin-bottom: 0;
        }
      }
    }
  }
</style>
